angular.module('eventcodeUsers', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/eventcode-users/eventcode-users.module.js